export default __webpack_public_path__ + "static/media/ic_bahrain.db2739b6.svg";